import { render } from "./TheNguonVonDauTu.vue?vue&type=template&id=03456814"
import script from "./TheNguonVonDauTu.vue?vue&type=script&lang=js"
export * from "./TheNguonVonDauTu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__